import { useState } from 'react';

import { Button } from '../../shared/ui/button';
import { DangerZone } from '../../shared/ui/danger-zone';
import { PlusIcon } from '../../shared/ui/icons';
import { isManager } from '../../entities/organization';
import {
  InvitationsPanel,
  InviteDialog,
  LeaveOrganization,
  MembersPanel,
  useMembers,
} from '../../features/members';
import { SettingsShell } from './settings-shell';
import { useOrganizationSettings } from './use-organization-settings';

export const MembersPage = () => {
  const { organization, actor, timeZone } = useOrganizationSettings();
  const members = useMembers();
  const [inviting, setInviting] = useState(false);
  const manager = isManager(actor);

  return (
    <SettingsShell
      active="/settings/members"
      question="Who can get into this organization, and what each person can do."
      actions={
        manager && (
          <Button size="sm" onClick={() => setInviting(true)}>
            <PlusIcon size={12} /> Invite people
          </Button>
        )
      }
    >
      <MembersPanel members={members} actor={actor} timeZone={timeZone} />
      <InvitationsPanel
        members={members}
        actor={actor}
        timeZone={timeZone}
        onInvite={() => setInviting(true)}
      />
      <DangerZone>
        <LeaveOrganization
          members={members}
          actor={actor}
          organizationId={organization.data?.id}
          organizationName={organization.data?.name}
        />
      </DangerZone>
      <InviteDialog open={inviting} onOpenChange={setInviting} actor={actor} members={members} />
    </SettingsShell>
  );
};
